import { render } from "./user-booking-inprogress.vue?vue&type=template&id=1e245d8c"
import script from "./user-booking-inprogress.vue?vue&type=script&lang=js"
export * from "./user-booking-inprogress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__